import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { canAccessServices } from "@/components/ProjectSidebar/permissions";

import { RequireAuth } from "../../components/Routing/RequireAuth";
import { canCreateNewServicePartner, canViewServicePartners } from "./permissions";
import { servicePartnersRoutes } from "./routes";

export const servicePartnersRoute = [
  {
    path: servicePartnersRoutes.list,
    lazy: async () => {
      const { ServicePartnerListPage } = await import("./pages/ServicePartnerListPage");

      return {
        element: (
          <RequireAuth permission={canAccessServices}>
            <ServicePartnerListPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: servicePartnersRoutes.details,
    lazy: async () => {
      const { ServicePartnerDetailsPage } = await import("./pages/ServicePartnerDetailsPage");

      return {
        element: (
          <RequireAuth permission={canViewServicePartners}>
            <ServicePartnerDetailsPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: servicePartnersRoutes.create,
    lazy: async () => {
      const { CreateServicePartnerPage } = await import("./pages/CreateServicePartnerPage");

      return {
        element: (
          <RequireAuth permission={canCreateNewServicePartner}>
            <CreateServicePartnerPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: servicePartnersRoutes.edit,
    lazy: async () => {
      const { EditServicePartnerPage } = await import("./pages/EditServicePartnerPage");

      return {
        element: (
          <RequireAuth permission={canViewServicePartners}>
            <EditServicePartnerPage />
          </RequireAuth>
        ),
      };
    },
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
